"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTargetAggregate = void 0;
const client_1 = require("@apollo/client");
const configContext_1 = require("../contexts/configContext");
const graphql_1 = require("../utils/graphql");
const aggregate_1 = require("../utils/aggregate");
const useTargetAggregate = (aggregateType, aggregateId) => {
    const { aggregateDefinitions } = configContext_1.useConfig();
    const aggregateDefinition = aggregateDefinitions.find(d => d.name === aggregateType);
    const aggregateTypeName = (aggregateDefinition === null || aggregateDefinition === void 0 ? void 0 : aggregateDefinition.queryKey) || '';
    const aggregateIds = Array.isArray(aggregateId) ? aggregateId : [aggregateId];
    const { data, loading, error, refetch } = client_1.useQuery(client_1.gql `
      query AssetData($aggregateIds: [UUID!]!) {
        ${aggregateTypeName}(filter: {id: {in: $aggregateIds}}) {
          id
          label
          assetAttributes
          modifiedDateTime
          ${graphql_1.getAggregateDataFields(aggregateDefinition)}
        }
      }
    `, {
        skip: !aggregateIds.length,
        variables: { aggregateIds },
        fetchPolicy: 'cache-and-network',
    });
    let record;
    if (data && data[aggregateTypeName]) {
        if (Array.isArray(aggregateId)) {
            record = data[aggregateTypeName].map(agg => aggregate_1.graphqlToAssetTransform({ flattenRelationships: true, result: agg, aggDef: aggregateDefinition }));
        }
        else {
            record = aggregate_1.graphqlToAssetTransform({
                flattenRelationships: true,
                result: data[aggregateTypeName][0],
                aggDef: aggregateDefinition,
            });
        }
    }
    return {
        loading,
        error,
        refetch,
        record,
    };
};
exports.useTargetAggregate = useTargetAggregate;
//# sourceMappingURL=useTargetAggregate.js.map